import { Component } from 'react'
import { PawViewProps } from '../index'
import { IPlugandworkApp } from '../interfaces/plugandwork-app'
import SettingsField from './SettingsField'
import View from '../models/View'

class PlugandworkApp implements IPlugandworkApp {
  static getSettingsFields() {
    const { schema } = this.settings

    if (!schema || typeof schema !== "object") {
      return [];
    }

    return Object.keys(schema).map((key) => {
      const schemaField = schema[key]

      if (schemaField instanceof SettingsField) {
        return schemaField
      }

      return new SettingsField(schema[key], key)
    })
  }

  static component: Component<PawViewProps>

  static publicComponent?: Component<PawViewProps>

  static settings: { schema?: any; defaults?: any } = {}

  static icon: any

  static handleDoc?: Function;

  static async onInstall(view: View) {}

  static async onUninstall(view: View) {}
}

export default PlugandworkApp
